import Http from '@/services/http'

// 获取验证码
export const getCode = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/p1/login/sms',
    params,
    method: 'post',
    returnAll: true
  })
}
/**
 * 登录
 * */
export const login = (params: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/p1/login/phone',
    params,
    method: 'post',
    returnAll: true
  })
}

export const getUserInfo = (params?: any) => {
  return Http.request({
    url: '/cwhCopilot/copilot/v1/account/getInfo',
    params,
    method: 'get',
    returnAll: true
  })
}
